import { useState, useRef } from 'react';
import QRCode from 'react-qr-code';
import * as htmlToImage from 'html-to-image';
import './App.css';

function QRGenerator() {
  const [value, setValue] = useState('');
  const qrRef = useRef(null);

  const downloadQR = () => {
    if (!value) return;
    htmlToImage.toPng(qrRef.current).then((dataUrl) => {
      const link = document.createElement('a');
      link.download = 'qr-code.png';
      link.href = dataUrl;
      link.click();
    });
  };

  return (
    <div className='main'>
        
            <div className="coolinput">
                <label htmlFor="input" className="text">QR value:</label>
                <input type="text" placeholder="Write here..." name="input" className="input" onChange={(e) => setValue(e.target.value)}/>            
            </div>
        
            <button onClick={downloadQR} className={value? 'active' : ''}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>
            </button>    
        
      {value && (
        <div ref={qrRef}>
          <QRCode value={value} size={256} bgColor="#FFFFFF" fgColor="#000000" />
        </div>
      )}
      
    </div>
  );
}

export default QRGenerator;
